import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ArrowRightIcon, SparklesIcon } from 'lucide-react';
interface CTASectionProps {
  onOpenOnboarding?: () => void;
}
export function CTASection({
  onOpenOnboarding
}: CTASectionProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="py-24 bg-dark-900 relative overflow-hidden" data-id="element-26">
      {/* Background elements */}
      <div className="absolute inset-0" data-id="element-27">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-yellow/10 rounded-full blur-3xl" data-id="element-28" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative" ref={ref} data-id="element-29">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-30">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-yellow/10 border border-brand-yellow/20 mb-8" data-id="element-31">
            <SparklesIcon className="w-4 h-4 text-brand-yellow" data-id="element-32" />
            <span className="text-sm font-medium text-brand-yellow" data-id="element-33">
              Limited spots available
            </span>
          </div>

          {/* Headline */}
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-34">
            Ready to transform
            <br data-id="element-35" />
            <span className="text-gradient-yellow" data-id="element-36">your design career?</span>
          </h2>

          {/* Subheadline */}
          <p className="text-xl text-gray-400 max-w-2xl mx-auto mb-10" data-id="element-37">
            Join 2,500+ designers who've already made the leap. Your future self
            will thank you.
          </p>

          {/* CTA Button */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8" data-id="element-38">
            <button onClick={onOpenOnboarding} className="group inline-flex items-center gap-2 px-10 py-5 text-lg font-semibold bg-brand-yellow text-dark-900 rounded-full hover:bg-brand-yellow-dark transition-all duration-300 hover:scale-105 glow-yellow" data-id="element-39">
              Enroll Now — Save 50%
              <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-40" />
            </button>
          </div>

          {/* Trust elements */}
          <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-gray-500" data-id="element-41">
            <span className="flex items-center gap-2" data-id="element-42">
              <svg className="w-4 h-4 text-green-500" fill="currentColor" viewBox="0 0 20 20" data-id="element-43">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-44" />
              </svg>
              14-day money-back guarantee
            </span>
            <span className="flex items-center gap-2" data-id="element-45">
              <svg className="w-4 h-4 text-green-500" fill="currentColor" viewBox="0 0 20 20" data-id="element-46">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-47" />
              </svg>
              Instant access
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}